// sw — checkin/quickCheck/stepTracker blocks translated.
export const sw = {
  "common": {
    "loading": "Inapakia…",
    "save": "Hifadhi",
    "cancel": "Ghairi",
    "delete": "Futa",
    "edit": "Hariri",
    "close": "Funga",
    "confirm": "Thibitisha",
    "back": "Rudi",
    "next": "Inayofuata",
    "submit": "Wasilisha",
    "search": "Tafuta",
    "select": "Chagua",
    "or": "Au",
    "and": "na",
    "note": "Note",
    "viewAll": "Tazama yote",
    "learnMore": "Jifunze zaidi",
    "getStarted": "Anza",
    "continue": "Endelea",
    "saving": "Inahifadhi…"
  },
  "offline": {
    "banner": "Hauko mtandaoni. Baadhi ya vipengele vinaweza kuwa na vikwazo.",
    "savedLocally": "Imehifadhiwa nje ya mtandao — itasawazishwa ukirudi mtandaoni",
    "syncing": "Inasawazisha masasisho yako…",
    "backOnline": "Umerudi mtandaoni — masasisho yamesawazishwa"
  },

  "nav": {
    "dashboard": "Dashibodi",
    "nutrition": "Lishe nadhifu",
    "family": "Familia",
    "care": "Huduma",
    "careShort": "Huduma",
    "checkIn": "Ujikague",
    "insights": "Insights",
    "trends": "Trends",
    "habits": "Habits",
    "medications": "Dawa",
    "expertSupport": "Expert Support",
    "profile": "Wasifu",
    "healthHub": "Health Hub",
    "support": "Msaada",
    "wellness": "Wellness",
    "education": "Education",
    "community": "Community",
    "preventiveHealth": "Preventive Health",
    "womensHealth": "Women's Health",
    "reminders": "Health Reminders",
    "meals": "Meals",
    "orders": "Orders",
    "subscription": "Subscription",
    "logout": "Toka"
  },

  "navShort": {
    "dashboard": "Mwanzo",
    "nutrition": "Lishe",
    "family": "Familia",
    "care": "Huduma",
    "support": "Msaada",
    "profile": "Wasifu"
  },
  "auth": {
    "login": "Ingia",
    "register": "Fungua akaunti",
    "logout": "Sign Out",
    "email": "Barua pepe",
    "password": "Nenosiri",
    "name": "Full Name",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Huna akaunti?",
    "haveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "welcomeBack": "Karibu tena!",
    "getStarted": "Let's get started",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "vendorLogin": "Vendor Login",
    "createOne": "Fungua akaunti",
    "tagline": "Tunza afya yako — jikague kidogo kila siku.",
    "takes30s": "Chini ya sekunde 30",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "Enter your password",
    "checking": "Checking…",
    "continue": "Endelea",
    "secureMessage": "Secure and private — your data stays protected",
    "biometricSoon": "Biometric login — Coming Soon",
    "showPassword": "Onyesha nenosiri",
    "hidePassword": "Ficha nenosiri",
    "vendor": {
      "title": "Ingia Kama Mshirika wa Biashara",
      "subtitle": "Fikia dashibodi yako ya muuzaji ya HealthLoop",
      "businessEmail": "Barua pepe ya Biashara",
      "emailPlaceholder": "muuzaji@biashara.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "Inaingia...",
      "signIn": "Ingia",
      "notVendorYet": "Je, bado wewe si mshirika wa biashara?",
      "registerBusiness": "Sajili biashara yako",
      "areYouUser": "Je, wewe ni mtumiaji wa kawaida?",
      "userLogin": "Ingia Kama Mtumiaji",
      "welcomeBackToast": "Karibu tena!",
      "genericError": "Imeshindikana kuingia. Tafadhali jaribu tena."
    },
    "admin": {
      "backToUserLogin": "Ingia kama mtumiaji",
      "title": "Ingia Kama Msimamizi",
      "restrictedBadge": "Imezuiwa",
      "tagline": "Dashibodi ya waendeshaji wa HealthLoop — kitambulisho cha msimamizi kinahitajika.",
      "emailLabel": "Barua pepe ya msimamizi",
      "emailPlaceholder": "msimamizi@domainyako.com",
      "passwordLabel": "Nenosiri",
      "passwordPlaceholder": "Weka nenosiri lako la msimamizi",
      "signingIn": "Inaingia...",
      "submit": "Ingia kwenye dashibodi ya msimamizi",
      "secureNote": "Muunganisho salama · kipindi kimesimbwa",
      "restrictedTitle": "Eneo hili ni la wasimamizi pekee.",
      "restrictedBody": "Akaunti yako imeingia, lakini haina idhini ya msimamizi. Ondoka ili ujaribu akaunti tofauti, au rudi kwenye programu kuu.",
      "signOut": "Ondoka",
      "backToApp": "Rudi kwenye programu"
    }
  },
  "quickCheck": {
    "header": {
      "title": "Unajisikiaje leo?",
      "subtitle": "Tathmini ya haraka — inachukua chini ya sekunde 60"
    },
    "section1": {
      "title": "Unahisi nini leo?",
      "hint": "(Chagua yote yanayohusika)"
    },
    "environment": {
      "title": "Mazingira yako leo",
      "hint": "Tusaidie kuelewa mazingira yanayokuzunguka"
    },
    "basicChecks": {
      "title": "Tathmini fupi za msingi",
      "hint": "Si lazima lakini inasaidia"
    },
    "validation": {
      "pickOne": "Tafadhali jibu angalau swali moja"
    },
    "submit": {
      "cta": "Pata Uchambuzi wa Afya Yangu",
      "saving": "Inahifadhi...",
      "analyzing": "Tunachambua mfumo wako wa afya...",
      "savedToast": "✅ Tathmini imehifadhiwa! Tunachambua mfumo wako wa afya..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "Kifuatilia Hatua",
      "subtitle": "Ufuatiliaji wa shughuli wa kweli na wa faragha",
      "backToDashboard": "Rudi kwenye dashibodi"
    },
    "today": {
      "title": "Hatua za leo",
      "goalProgress": "Hatua {{current}} / {{goal}}",
      "goalReached": "Lengo limefikiwa — kazi nzuri!",
      "keepGoing": "Endelea hivyohivyo — uko kwenye mstari sahihi."
    },
    "streak": {
      "label": "Mfululizo wa sasa",
      "days": "Siku {{count}}",
      "daysPlural": "Siku {{count}}"
    },
    "badges": {
      "title": "Beji",
      "empty": "Utajipatia beji unavyozidi kujenga mazoea haya."
    },
    "reminders": {
      "title": "Kumbusho za kutembea",
      "hint": "Kumbusho za upole za kutembea kidogo unapokaa kwa muda mrefu.",
      "enabled": "Imewezeshwa",
      "disabled": "Imezimwa"
    },
    "insights": {
      "weeklyAverage": "Wastani wa wiki",
      "weeklyGoal": "Lengo la wiki"
    },
    "actions": {
      "connect": "Unganisha chanzo cha hatua",
      "manualLog": "Rekodi hatua kwa mkono",
      "changeGoal": "Badilisha lengo la kila siku"
    },
    "offline": {
      "title": "Hali ya nje ya mtandao imewashwa",
      "body": "Ufuatiliaji unaendelea hata ukiwa nje ya mtandao. Tutalandanisha masasisho yako utakaporejea mtandaoni."
    },
    "permission": {
      "title": "Unganisha kwa ufuatiliaji wa hatua otomatiki",
      "body": "Ruhusu HealthLoop kusoma data yako ya {{platform}}. Data yako ya afya hubaki kwenye kifaa chako isipokuwa uchague kuilandanisha.",
      "connect": "Unganisha",
      "maybeLater": "Labda baadaye"
    },
    "sync": {
      "lastSynced": "Ilirekebishwa mwisho {{time}}",
      "queued": "Sasisho {{count}} linasubiri kulandanishwa.",
      "queuedPlural": "Masasisho {{count}} yanasubiri kulandanishwa.",
      "disconnect": "Tenganisha",
      "refreshAria": "Onyesha upya ulandanishaji"
    },
    "progress": {
      "title": "Maendeleo ya leo",
      "stepsToday": "hatua leo",
      "goalLabel": "Lengo: {{goal}}",
      "stepsToGo": "Hatua {{remaining}} zilizosalia",
      "goalAchieved": "🎉 Lengo limefikiwa",
      "goalAriaLabel": "Lengo limefikiwa",
      "statGoal": "Lengo",
      "statProgress": "Maendeleo",
      "statSource": "Chanzo",
      "sourceDevice": "Kifaa",
      "sourceManual": "Mwenyewe"
    },
    "empty": {
      "waiting": "Inasubiri data ya shughuli",
      "startMoving": "Anza kutembea ili kuanza ufuatiliaji",
      "shortWalkHint": "Tembea kidogo ili kujaribu ufuatiliaji — au ingiza nyaraka mwenyewe hapa chini."
    },
    "manual": {
      "title": "Ingiza hatua mwenyewe",
      "placeholder": "Ingiza hatua",
      "submit": "Ingiza",
      "footer": "Maingizo ya mkono yanachukua nafasi ya hesabu ya leo. Yatasawazishwa kiotomatiki ukiwa mtandaoni."
    },
    "trust": {
      "title": "Faragha kwa msingi",
      "itemData": "Data yako ya afya inabaki kwenye kifaa chako isipokuwa ulandanishe na akaunti yako.",
      "itemOffline": "Ufuatiliaji unaendelea hata ukiwa nje ya mtandao — masasisho yanapanga na kusawazishwa unaporejea.",
      "itemNoInvent": "Hatuwezi kamwe kuvumbua idadi ya hatua. Ni thamani tu kutoka kwa kifaa chako au maingizo yako ya mkono yanayohifadhiwa."
    },
    "howItWorks": {
      "title": "Jinsi inavyofanya kazi",
      "itemConnect": "Unganisha programu ya afya ya kifaa chako kwa ufuatiliaji bila mikono.",
      "itemManual": "Uingizaji wa mkono unapatikana kila wakati kama nakala mbadala ya kuaminika.",
      "itemOfflineQueue": "Masasisho ya nje ya mtandao yanapanga kwenye kifaa na kusawazishwa mara tu unaporejea mtandaoni.",
      "itemDisconnect": "Tenganisha wakati wowote — historia yako iliyoandikwa inabaki kwenye kifaa hiki."
    }
  },
  "checkin": {
    "header": {
      "title": "Tathmini ya Afya ya Kila Siku",
      "subtitle": "Inachukua chini ya sekunde 60",
      "restDayLink": "Sijisikii vizuri leo"
    },
    "snapshot": {
      "title": "Dashibodi yako, imesasishwa",
      "healthScore": "Alama ya afya",
      "todayTasks": "Kazi za leo",
      "dayStreak": "mfululizo wa siku"
    },
    "resume": {
      "banner": "Imeendelea pale ulipoishia",
      "startFresh": "Anza upya",
      "dismiss": "Ondoa"
    },
    "progress": {
      "allSet": "Tayari",
      "step": "Hatua ya {{current}} kati ya {{total}}",
      "ariaLabel": "Maendeleo ya tathmini ya kila siku: sehemu {{done}} kati ya {{total}} zimekamilika"
    },
    "insights": {
      "title": "Uchambuzi wa Afya Yako",
      "subtitle": "Imeandaliwa kwa ajili yako leo",
      "insightForYou": "Uchambuzi kwa ajili yako",
      "simpleActions": "Hatua rahisi unazoweza kuchukua",
      "whenToSeekHelp": "Wakati wa kutafuta msaada",
      "nhsAdvice": "Ikiwa una wasiwasi, wasiliana na NHS 111 au daktari wako wa familia (GP)",
      "backToDashboard": "Rudi kwenye Dashibodi",
      "newCheckIn": "Tathmini Mpya",
      "disclaimer": "HealthLoop hutoa mwongozo wa ustawi, si utambuzi wa ugonjwa."
    },
    "restDay": {
      "title": "Mapumziko ni sehemu ya mfumo wa maisha.",
      "body": "Tutakuwepo hapa kesho, ukiwa tayari.",
      "streakNote": "Mfululizo wako haujabadilika — unapumzika pia.",
      "backToDashboard": "Rudi kwenye dashibodi",
      "changedMind": "Kwa kweli, ningependa kufanya tathmini hata hivyo."
    },
    "feelings": {
      "title": "Unajisikiaje leo?",
      "hint": "Chagua yote yanayohusika",
      "tired": "Najisikia mchovu",
      "headache": "Kuumwa na kichwa",
      "stressed": "Msongo wa mawazo au kulemewa",
      "pain": "Maumivu ya mwili",
      "okay": "Najisikia vizuri leo"
    },
    "basics": {
      "title": "Mambo ya msingi",
      "sleepQ": "Je, ulilala vizuri usiku wa kuamkia leo?",
      "waterQ": "Je, umekunywa maji ya kutosha leo?",
      "foodQ": "Je, umekula vizuri leo?",
      "activityQ": "Ulikuwa na shughuli kiasi gani leo?",
      "yes": "Ndiyo",
      "notReally": "Sio kiasi hicho",
      "notYet": "Bado",
      "notActive": "Sikuwa na shughuli",
      "lightActivity": "Shughuli kidogo",
      "active": "Shughuli nyingi"
    },
    "mind": {
      "title": "Akili na nguvu",
      "stressQ": "Kiwango chako cha msongo wa mawazo kikoje leo?",
      "moodQ": "Mood yako ikoje leo?",
      "energyQ": "Kiwango chako cha nguvu kikoje leo?",
      "low": "Chini",
      "moderate": "Wastani",
      "high": "Juu",
      "neutral": "Kawaida",
      "good": "Nzuri",
      "okay": "Salama"
    },
    "day": {
      "title": "Siku yako",
      "routineQ": "Je, ulifuata utaratibu wako wa kawaida leo?",
      "yes": "Ndiyo",
      "no": "Hapana"
    },
    "environment": {
      "title": "Mazingira yako leo",
      "describeQ": "Unawezaje kuelezea mazingira yako?",
      "comfortable": "😊 Yanaridhisha",
      "slightlyUncomfortable": "😐 Hayaridhishi kidogo",
      "challenging": "😓 Ni magumu",
      "affectedQ": "Je, mazingira yako yameathiri jinsi unavyohisi?",
      "yes": "Ndiyo",
      "no": "Hapana",
      "exposureLabel": "Mfiduo (chagua yote yanayohusika)",
      "heat": "🌡️ Joto",
      "cold": "❄️ Baridi",
      "noise": "🔊 Kelele",
      "dustSmoke": "💨 Vumbi au moshi",
      "crowded": "👥 Msongamano wa watu",
      "none": "✅ Hakuna"
    },
    "submit": {
      "analyzing": "Tunachambua mfumo wako wa afya...",
      "cta": "Angalia Uchambuzi wa Afya Yangu"
    },
    "toast": {
      "savedFull": "Tathmini imehifadhiwa! Dashibodi yako imesasishwa.",
      "savedShort": "Tathmini imehifadhiwa."
    }
  },
  "onboarding": {
    "welcome": "Welcome",
    "completeSetup": "Complete Setup",
    "stepProgress": "Step {{step}} of {{total}}",
    "percentComplete": "{{percent}}% complete",
    "welcomeToast": "Welcome to HealthLoop! Your profile is set up.",
    "errorAgeRange": "Please select your age range",
    "errorCountry": "Please select your country",
    "errorGoal": "Please select your primary health goal",
    "errorCuisine": "Please select at least one cuisine preference",
    "errorGeneric": "Failed to complete onboarding. Please try again.",
    "step1Title": "Welcome to HealthLoop! 👋",
    "step1Subtitle": "Let's personalize your health journey",
    "ageRangeLabel": "What's your age range?",
    "genderLabel": "Gender (Optional)",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_non-binary": "Non-binary",
    "gender_prefer_not_to_say": "Prefer not to say",
    "step2Title": "Where are you based? 🌍",
    "step2Subtitle": "This helps us recommend culturally relevant meals",
    "countryLabel": "Select your country",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Other",
    "step3Title": "What's your main goal? 🎯",
    "step3Subtitle": "Choose your primary health objective",
    "additionalGoals": "Any other goals? (Optional)",
    "goal_weight_loss": "Weight Loss",
    "goalDesc_weight_loss": "Lose weight healthily",
    "goal_weight_maintenance": "Maintain Weight",
    "goalDesc_weight_maintenance": "Stay at current weight",
    "goal_muscle_gain": "Build Muscle",
    "goalDesc_muscle_gain": "Gain strength & muscle",
    "goal_general_wellness": "General Wellness",
    "goalDesc_general_wellness": "Overall health improvement",
    "goal_better_sleep": "Better Sleep",
    "goalDesc_better_sleep": "Improve sleep quality",
    "goal_reduce_stress": "Reduce Stress",
    "goalDesc_reduce_stress": "Manage stress better",
    "goal_increase_energy": "More Energy",
    "goalDesc_increase_energy": "Feel more energized",
    "step4Title": "Food preferences 🍽️",
    "step4Subtitle": "Select cuisines you enjoy and any dietary restrictions",
    "cuisineLabel": "Preferred Cuisines",
    "cuisineHint": "Select at least one (you can choose multiple)",
    "dietaryLabel": "Dietary Restrictions (Optional)",
    "diet_vegetarian": "Vegetarian",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Gluten-Free",
    "diet_dairy_free": "Dairy-Free",
    "diet_pescatarian": "Pescatarian",
    "step5Title": "Health conditions 🏥",
    "step5Subtitle": "Optional — helps us provide better recommendations",
    "conditionsLabel": "Do you have any of these conditions?",
    "conditionsHint": "This information is private and helps personalize your experience",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "High Blood Pressure",
    "condition_heart_disease": "Heart Disease",
    "condition_thyroid": "Thyroid Issues",
    "condition_celiac": "Celiac Disease",
    "condition_ibs": "IBS",
    "condition_none": "None",
    "privacyTitle": "Your data is protected",
    "privacyBody": "Your personal information is encrypted and stored securely. We use this data only to personalise your experience with tailored meal recommendations, health tips, and notifications. Your data will never be shared with third parties without your explicit consent.",
    "trackMedication": "I want to track my medications",
    "specialistInterest": "I'm interested in specialist consultations",
    "welcomeTitle": "Karibu HealthLoop! 👋",
    "welcomeSubtitle": "Hebu tuandae mfumo wako wa kuzuia magonjwa na akili ya mfumo wa maisha kwa hatua chache rahisi",
    "stepLabel": "Hatua ya {{current}} kati ya {{total}}",
    "skipForNow": "Ruka kwa sasa",
    "skipToast": "Unaweza kukamilisha usajili huu wakati wowote kupitia wasifu wako",
    "back": "Rudi",
    "next": "Endelea",
    "completing": "Inakamilisha...",
    "complete": "Kamilisha Usanidi",
    "successToast": "Karibu HealthLoop! Wasifu wako sasa umeandaliwa kwa ajili yako 🎉",
    "failureToast": "Imeshindikana kukamilisha usajili",
    "validation": {
      "basicInfo": "Tafadhali jaza taarifa zote za msingi",
      "pickGoal": "Tafadhali chagua angalau lengo moja la ustawi",
      "pickPrimary": "Tafadhali chagua lengo lako kuu",
      "pickRegion": "Tafadhali chagua eneo lako la kitamaduni kwa mapendekezo ya milo",
      "pickFocus": "Tafadhali chagua msisitizo wako mkuu wa ustawi"
    },
    "step1": {
      "title": "Wasifu Wako wa Ustawi",
      "description": "Tusaidie kuunda mfumo wako wa akili wa afya uliogeuzwa kukufaa",
      "age": "Umri *",
      "agePlaceholder": "mfano, 30",
      "height": "Urefu (cm) *",
      "heightPlaceholder": "mfano, 170",
      "weight": "Uzito (kg) *",
      "weightPlaceholder": "mfano, 70"
    },
    "step2": {
      "title": "Malengo Yako ya Ustawi",
      "description": "Chagua yote yanayokuhusu, kisha chagua lengo lako kuu",
      "primaryLabel": "Chagua Lengo Lako Kuu *",
      "primaryBadge": "Kuu"
    },
    "step3": {
      "title": "🌍 Utamaduni na Mapendeleo ya Chakula",
      "description": "Tusaidie kubinafsisha mapendekezo yako ya milo",
      "regionLabel": "Eneo la Kitamaduni *",
      "regionHint": "Chagua asili yako ya kitamaduni kwa mapendekezo ya milo yanayokufaa",
      "countryLabel": "Nchi (Si lazima)",
      "countryPlaceholder": "mfano, Kenya, Tanzania, Uganda",
      "countryHint": "Kwa mapendekezo yaliyobinafsishwa zaidi",
      "foodPrefLabel": "Mapendeleo ya Aina za Chakula"
    },
    "step4": {
      "title": "Msisitizo Mkuu wa Ustawi",
      "description": "Chagua eneo ambalo ungependa kutilia mkazo zaidi"
    },
    "step5": {
      "title": "Mapendeleo Yako",
      "description": "Rekebisha uzoefu wako wa HealthLoop upendavyo",
      "trackMeds": "Fuatilia Ratiba za Dawa",
      "trackMedsHint": "Washa ufuatiliaji na ukumbusho wa dawa katika ukaguzi wako wa kila siku",
      "specialist": "Ninahitaji Msaada wa Wataalamu",
      "specialistHint": "Pata ufikiaji wa wataalamu wa ustawi, washauri wa lishe, na wataalamu wa afya ya akili",
      "confidentialTitle": "Msaada wa Siri:",
      "confidentialBody": "Taarifa zako zote zinalindwa na hutumiwa tu kutoa maarifa ya kuzuia magonjwa yaliyobinafsishwa."
    },
    "step6": {
      "title": "Ubinafsishaji wa Milo",
      "description": "Tusaidie kupendekeza milo inayolingana na ladha na mahitaji yako ya lishe",
      "cuisinesLabel": "Mapishi Unayopenda (Si lazima)",
      "cuisinesHint": "Chagua aina za mapishi unayofurahia zaidi",
      "dietaryLabel": "Vizuizi vya Lishe (Si lazima)",
      "dietaryHint": "Chagua yoyote yanayokuhusu",
      "allergiesLabel": "Mizio ya Kawaida (Si lazima)",
      "allergiesHint": "Chagua mizio yoyote ya chakula",
      "personalisedTitle": "Milo Iliyobinafsishwa:",
      "personalisedBody": "Tutatumia mapendeleo haya kupendekeza milo inayolingana na ladha na mahitaji yako. Unaweza kuyabadilisha baadaye kwenye Mipangilio."
    },
    "healthGoals": {
      "better_sleep": "Kulala Bora",
      "reduce_stress": "Kupunguza Msongo",
      "increase_energy": "Kuongeza Nguvu",
      "weight_management": "Kudhibiti Uzito",
      "improve_fitness": "Kuimarisha Mazoezi",
      "better_nutrition": "Lishe Bora",
      "mental_wellness": "Ustawi wa Akili",
      "chronic_condition": "Kudhibiti Hali ya Kudumu"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "Afya ya Akili",
        "description": "Zingatia hisia, msongo wa mawazo, na ustawi wa kihisia"
      },
      "physical_fitness": {
        "label": "Uimara wa Mwili",
        "description": "Zingatia mazoezi, nguvu, na harakati"
      },
      "nutrition": {
        "label": "Lishe",
        "description": "Zingatia mlo na ulaji bora"
      },
      "sleep": {
        "label": "Ubora wa Usingizi",
        "description": "Zingatia mapumziko, mifumo ya kulala, na kupata nafuu"
      },
      "stress_management": {
        "label": "Udhibiti wa Msongo",
        "description": "Zingatia utulivu na kupunguza msongo wa mawazo"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "Afrika Magharibi",
        "description": "Mapishi ya Kinigeria, Kighana, Kisenegali"
      },
      "east_african": {
        "label": "Afrika Mashariki",
        "description": "Mapishi ya Kikenya, Kiepiothia, Kitanzania"
      },
      "north_african": {
        "label": "Afrika Kaskazini",
        "description": "Mapishi ya Kimoroko, Kimisri"
      },
      "southern_african": {
        "label": "Kusini mwa Afrika",
        "description": "Mapishi ya Afrika Kusini"
      },
      "caribbean": {
        "label": "Karibiani",
        "description": "Mapishi ya Kijamaika, Kitrinidadi, Kibarbados"
      },
      "middle_eastern": {
        "label": "Mashariki ya Kati",
        "description": "Mapishi ya Kilebanoni, Kipalestina, Kisyria"
      },
      "south_asian": {
        "label": "Asia Kusini",
        "description": "Mapishi ya Kihindi, Kipakistani, Kibangladeshi"
      },
      "east_asian": {
        "label": "Asia Mashariki",
        "description": "Mapishi ya Kichina, Kijapani, Kikorea"
      },
      "southeast_asian": {
        "label": "Asia Kusini-Mashariki",
        "description": "Mapishi ya Kithai, Kivietinamu, Kiindonesia"
      },
      "western": {
        "label": "Magharibi",
        "description": "Mapishi ya Kimarekani na Kiulaya"
      },
      "latin_american": {
        "label": "Amerika ya Kusini",
        "description": "Mapishi ya Kimeksiko, Kibrazili, Kiargentina"
      },
      "mediterranean": {
        "label": "Mediterania",
        "description": "Mapishi ya Kigiriki, Kiitaliano, Kihispania"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "Asilia",
        "description": "Milo hasa kutoka eneo lako la kitamaduni"
      },
      "mixed": {
        "label": "Mchanganyiko",
        "description": "Uwiano wa vyakula vya asili na vya kimataifa"
      },
      "international": {
        "label": "Kimataifa",
        "description": "Mapishi mbalimbali kutoka kote duniani"
      }
    },
    "cuisines": {
      "west_african": "Afrika Magharibi",
      "caribbean": "Karibiani",
      "mediterranean": "Mediterania",
      "asian": "Asia",
      "western": "Magharibi",
      "indian": "Kihindi",
      "middle_eastern": "Mashariki ya Kati",
      "general": "Mapishi Yote"
    },
    "dietary": {
      "vegetarian": "Mla Mboga",
      "vegan": "Vegan",
      "pescatarian": "Mla Samaki",
      "gluten_free": "Bila Gluteni",
      "dairy_free": "Bila Maziwa",
      "low_carb": "Wanga Chache"
    },
    "allergies": {
      "nuts": "Karanga",
      "shellfish": "Samaki wenye Magamba",
      "dairy": "Maziwa",
      "eggs": "Mayai",
      "soy": "Soya",
      "gluten": "Gluteni"
    },
    "cuisine_nigerian": "Kinigeria",
    "cuisine_ghanaian": "Kighana",
    "cuisine_senegalese": "Kisenegali",
    "cuisine_kenyan": "Kikenya",
    "cuisine_ethiopian": "Kiethiopia",
    "cuisine_moroccan": "Kimoroko",
    "cuisine_south_african": "Kiazubia Kusini",
    "cuisine_jamaican": "Kijamaika",
    "cuisine_trinidadian": "Kitrinidadi",
    "cuisine_lebanese": "Kilebanoni",
    "cuisine_turkish": "Kituruki",
    "cuisine_greek": "Kiyunani",
    "cuisine_italian": "Kiitaliano",
    "cuisine_french": "Kifaransa",
    "cuisine_british": "Kiingereza",
    "cuisine_indian_south": "Kihindi cha Kusini",
    "cuisine_indian_north": "Kihindi cha Kaskazini",
    "cuisine_pakistani": "Kipakistani",
    "cuisine_japanese": "Kijapani",
    "cuisine_chinese": "Kichina",
    "cuisine_korean": "Kikorea",
    "cuisine_vietnamese": "Kivietinamu",
    "cuisine_thai": "Kitailandi",
    "cuisine_filipino": "Kifilipino",
    "cuisine_american": "Kimarekani",
    "cuisine_mexican": "Kimeksiko",
    "cuisine_brazilian": "Kibrazili",
    "cuisine_peruvian": "Kiperuu"
  },
  "dashboard": {
    "welcome": "Karibu tena",
    "greeting": "Hello",
    "goodMorning": "Habari za asubuhi",
    "goodAfternoon": "Habari za mchana",
    "goodEvening": "Habari za jioni",
    "tagline": "Hatua ndogo zenye afya zinazaa mabadiliko ya kudumu",
    "microcopy": "Your wellness journey matters.",
    "welcomeSubtitleMorning1": "A calm start to the day.",
    "welcomeSubtitleMorning2": "Glad you stopped by this morning.",
    "welcomeSubtitleMorning3": "Small moments add up.",
    "welcomeSubtitleAfternoon1": "Hope your day feels steady.",
    "welcomeSubtitleAfternoon2": "Welcome back to HealthLoop.",
    "welcomeSubtitleAfternoon3": "Take a breath — you're doing well.",
    "welcomeSubtitleEvening1": "Winding down with you.",
    "welcomeSubtitleEvening2": "A gentle close to the day.",
    "welcomeSubtitleEvening3": "Welcome back this evening.",
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate",
    "summary": "Your Health Intelligence Summary",
    "summaryDesc": "Real-time insights across prevention, education, engagement, and wellness",
    "comprehensiveSupport": "Comprehensive support across prevention, education, engagement, and wellness",
    "todayCheckIn": "Kujikagua leo",
    "quickActions": "Vitendo vya haraka",
    "healthOverview": "Health Overview",
    "recentActivity": "Recent Activity",
    "viewAll": "Tazama yote",
    "preventiveHealth": "Preventive Health",
    "preventiveHealthDesc": "Daily tracking, wellness monitoring & preventive alerts",
    "education": "Education",
    "educationDesc": "Evidence-based insights, health articles & expert guidance",
    "engagement": "Engagement",
    "engagementDesc": "Community challenges, habit tracking & social support",
    "wellness": "Wellness",
    "wellnessDesc": "Smart nutrition, lifestyle balance & holistic well-being",
    "todaysInsight": "Today's Insight",
    "wellnessScore": "Wellness Score",
    "healthStreak": "Health Streak",
    "days": "siku",
    "logHealth": "Log Health",
    "getEducated": "Get Educated",
    "communityChallenge": "Community Challenge",
    "checkWellness": "Check Wellness",
    "verified": "Verified",
    "joinCommunity": "Join Community",
    "personalizedPlan": "Personalized Plan",
    "score": "Score",
    "checkIns": "check-ins",
    "habits": "habits",
    "preventive": "Preventive",
    "healthMetrics": "Health Metrics",
    "trackMetrics": "Track Metrics",
    "startTracking": "Start tracking",
    "logMetrics": "Log Metrics",
    "dailyInsight": "Daily Insight",
    "learnAbout": "Learn about preventive health today",
    "articlesAvailable": "articles available",
    "browseArticles": "Browse Articles",
    "currentStreak": "Current Streak",
    "keepGoing": "Keep it going!",
    "startStreak": "Start your streak",
    "checkIn": "Check In",
    "nutritionPlan": "Nutrition Plan",
    "mealsPlanned": "meals planned",
    "viewPlan": "View Plan",
    "planYourWeek": "Plan your week",
    "moodStress": "Mood & Stress",
    "howFeeling": "How are you feeling?",
    "logWellness": "Log Wellness",
    "medications": "Medications",
    "noMeds": "No meds tracked",
    "addMedications": "Add your medications",
    "daysTracked": "Days Tracked",
    "noHabits": "No habits yet",
    "startTrackingHabits": "Start tracking habits",
    "insights": "Insights",
    "noInsights": "No insights yet",
    "completeFirstPlan": "Complete your first plan",
    "noCheckIns": "No check-ins yet",
    "startFirstCheckIn": "Start your first check-in"
  },
  "support": {
    "title": "Msaada",
    "subtitle": "Pata majibu, wasiliana nasi, au ripoti tatizo",
    "backToSettings": "Rudi kwenye mipangilio",
    "privacyBanner": "Support requests are handled privately and securely. Your health information stays confidential.",
    "section1": "Section 1",
    "section2": "Section 2",
    "section3": "Section 3",
    "section4": "Section 4",
    "navHelpCenter": "Help Center",
    "navContact": "Contact Support",
    "navHealth": "Health Services",
    "navTechnical": "Technical Support",
    "helpCenterTitle": "Help Center",
    "helpCenterSubtitle": "Search common questions and find quick answers.",
    "contactTitle": "Contact Support",
    "contactSubtitle": "Reach our team through your preferred channel.",
    "healthServicesTitle": "Health Services",
    "healthServicesSubtitle": "Connect with medication tracking and clinical experts.",
    "technicalTitle": "Technical Support",
    "technicalSubtitle": "Report bugs or technical issues with detailed context.",
    "searchPlaceholder": "Search common questions…",
    "liveChat": "Live Chat",
    "emailUs": "Email Us",
    "callBack": "Schedule a callback",
    "sendMessage": "Send a message",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Your name",
    "yourEmail": "Your email",
    "subject": "Subject",
    "message": "Message",
    "phone": "Phone",
    "description": "Description",
    "submit": "Submit",
    "successTitle": "Message sent",
    "successDescription": "We'll reply within 24–48 hours.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Smart Nutrition",
    "basedOnGoal": "Based on your goal:",
    "personalizedData": "Personalized based on your recent health data",
    "evidenceBased": "Evidence-based nutrition as part of your preventive health plan",
    "todaysMealSuggestions": "Today's Meal Suggestions",
    "customize": "Customize",
    "breakfast": "Breakfast",
    "lunch": "Lunch",
    "dinner": "Dinner",
    "loadingBreakfast": "Loading breakfast...",
    "loadingLunch": "Loading lunch...",
    "loadingDinner": "Loading dinner...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Swap Meal",
    "healthyOptionsNearYou": "Healthy Options Near You",
    "enableLocation": "Enable location",
    "view": "View",
    "discoverOptions": "Discover healthy restaurants, grocery stores, and meal prep vendors near you",
    "cuisinesSelected": "cuisines selected",
    "cuisineSelected": "cuisine selected",
    "dietaryPrefs": "dietary prefs",
    "dietaryPref": "dietary pref",
    "customizeMeals": "Customize meals to match your cultural preferences and dietary needs",
    "subtitleAdaptive": "Culturally adaptive, personalized meal planning for your health goals",
    "hideFavorites": "Hide Favorites",
    "viewFavorites": "View Favorites",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "View Full Plan",
    "exploreRecipes": "Explore Recipes"
  },
  "location": {
    "permissionTitle": "Find healthy options near you",
    "permissionDesc": "Used to recommend restaurants, grocery stores, and meal prep vendors aligned with your health goals.",
    "howToEnable": "How to enable:",
    "step1": "Click the lock icon 🔒 in your browser's address bar",
    "step2": "Find \"Location\" permissions",
    "step3": "Change to \"Allow\"",
    "step4": "Refresh this page",
    "refreshPage": "Refresh Page",
    "allowLocation": "Allow Location",
    "notNow": "Not now",
    "denied": "Location access was blocked. To see nearby healthy options, you'll need to enable location permissions.",
    "unavailable": "Location information is currently unavailable. Please check your device settings.",
    "error": "Unable to access your location. Please try again or check browser settings.",
    "unsupported": "Your browser doesn't support location services. Try using a modern browser like Chrome, Firefox, or Safari.",
    "accessRequired": "Location Access Required"
  },
  "womensHealth": {
    "title": "Women's Health",
    "description": "Track your cycle, log symptoms, and get personalized wellness tips based on your cycle phase",
    "cycleTracking": "Cycle Tracking",
    "symptomLogging": "Symptom Logging",
    "phaseInsights": "Phase Insights",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Insights",
    "tips": "Health Tips",
    "overview": "Overview",
    "history": "History",
    "startTracking": "Start Tracking Your Cycle"
  },
  "profile": {
    "title": "Wasifu",
    "personalInfo": "Personal Information",
    "healthProfile": "Health Profile",
    "preferences": "Preferences",
    "language": "Language",
    "selectLanguage": "Select Language",
    "notifications": "Notifications",
    "privacy": "Privacy",
    "security": "Security",
    "quickAccess": "Quick Access",
    "editProfile": "Hariri wasifu",
    "viewStats": "View Stats",
    "backToDashboard": "Rudi kwenye dashibodi",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Support & Help",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Give Feedback",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Report a Problem",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Basic Information",
    "fullName": "Full Name",
    "email": "Email",
    "dateOfBirth": "Date of Birth",
    "gender": "Gender",
    "height": "Height (cm)",
    "weight": "Weight (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "account": "Account",
    "appearance": "Appearance",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "languageNote": "Baadhi ya lugha mpya zimetafsiriwa kwa AI na zinasubiri uhakiki wa wazungumzaji asilia.",
    "languageUpdated": "Language updated successfully",
    "starterBadge": "Starter",
    "starterBadgeTooltip": "Imetafsiriwa na mashine — uhakiki wa mzawa unatarajiwa.",
    "regions": {
      "global": "Ulimwenguni",
      "european": "Lugha za Ulaya",
      "middleEastern": "Lugha za Mashariki ya Kati",
      "asian": "Lugha za Asia",
      "african": "Lugha za Kiafrika"
    }
  },
  "search": {
    "triggerLabel": "Tafuta kwenye HealthLoop",
    "triggerHint": "Jaribu \"hatua\", \"famasia\" au \"ujauzito\"",
    "triggerAriaLabel": "Fungua utafutaji mkuu",
    "placeholder": "Tafuta vipengele, vifuatiliaji, msaada...",
    "inputAriaLabel": "Tafuta vipengele vya HealthLoop",
    "modalAriaLabel": "Tafuta kwenye HealthLoop",
    "close": "Funga",
    "clear": "Futa",
    "clearAriaLabel": "Futa utafutaji",
    "recentSearches": "Utafutaji wa hivi karibuni",
    "tryFor": "Jaribu kutafuta",
    "findFeatures": "Pata kipengele chochote kwa sekunde chache.",
    "searchAcross": "Tafuta kwenye",
    "and": "na",
    "sections": {
      "home": "Nyumbani",
      "nutrition": "Lishe",
      "family": "Familia",
      "services": "Huduma",
      "support": "Msaada",
      "profile": "Wasifu"
    },
    "noMatchesFor": "Hakuna matokeo ya \"{{query}}\"",
    "trySimpler": "Jaribu neno rahisi kama hatua, lishe au mtaalamu.",
    "comingSoonBadge": "Inakuja hivi karibuni",
    "escToClose": "kufunga",
    "resultSingular": "tokeo {{count}}",
    "resultPlural": "matokeo {{count}}",
    "searchAcrossApp": "Tafuta kwenye programu nzima"
  },
  "familyMember": {
    "confirmRemove": "Ondoa {{name}} kwenye ufuatiliaji wa afya ya familia?",
    "removed": "{{name}} ameondolewa kwenye familia",
    "removeFailed": "Imeshindikana kuondoa mwanachama",
    "viewDetails": "Angalia Maelezo",
    "edit": "Hariri",
    "remove": "Ondoa",
    "yearsSuffix": "miaka",
    "healthGoalsLabel": "Malengo ya Afya:",
    "moreSuffix": "zaidi",
    "activeInsights": "Taarifa Muhimu",
    "viewAllInsights": "Angalia taarifa zote {{count}} →",
    "viewFullProfile": "Angalia Wasifu Kamili wa Afya",
    "lifeStage": {
      "infant": "Mchanga (0-2)",
      "toddler": "Mtoto mdogo (2-5)",
      "child": "Mtoto (6-12)",
      "adolescent": "Kijana (13-17)",
      "adult": "Mtu mzima (18-59)",
      "senior": "Mzee (60+)",
      "unknown": "Haijulikani"
    }
  },
  "profileDeep": {
    "backToDashboard": "Rudi kwenye dashibodi",
    "profileCompletion": "Ukamilifu wa wasifu",
    "healthSummary": "Muhtasari wa afya",
    "sectionA": "Sehemu A",
    "sectionB": "Sehemu B",
    "sectionC": "Sehemu C",
    "sectionD": "Sehemu D",
    "personalDetails": "Maelezo ya kibinafsi",
    "healthInformation": "Maelezo ya afya",
    "accountSettings": "Mipangilio ya akaunti",
    "fullName": "Jina kamili",
    "email": "Barua pepe",
    "dob": "Tarehe ya kuzaliwa",
    "gender": "Jinsia",
    "genderPlaceholder": "mfano: Mwanamke, Mwanaume",
    "height": "Urefu (sm)",
    "heightPlaceholder": "mfano: 170",
    "weight": "Uzito (kg)",
    "weightPlaceholder": "mfano: 70",
    "allergies": "Mzio",
    "allergiesPlaceholder": "mfano: Karanga",
    "medicalConditions": "Hali za kiafya",
    "conditionsPlaceholder": "mfano: Shinikizo la damu",
    "medications": "Dawa",
    "medicationsPlaceholder": "mfano: Lisinopril 10mg, kila siku",
    "emergencyContact": "Mawasiliano ya dharura",
    "emergencyOptional": "(si lazima)",
    "emergencyPlaceholder": "mfano: Mama +254-700-000-000",
    "emergencyNote": "Inajumuishwa tu unaposhirikiana na daktari.",
    "saveChanges": "Hifadhi mabadiliko",
    "saving": "Inahifadhi…",
    "editProfile": "Hariri wasifu",
    "cancelEditing": "Ghairi uhariri",
    "healthScore": "Alama ya afya",
    "streak": "Mfululizo",
    "streakDays": "siku {{n}}",
    "memberSince": "Mwanachama tangu",
    "remindersActive": "Vikumbusho hai",
    "conditionsTracked": "Hali zinazofuatiliwa",
    "nextAgenda": "Inayofuata kwenye ratiba yako",
    "notificationsReminders": "Arifa na vikumbusho",
    "notificationsRemindersDesc": "Simamia muda na njia za vikumbusho",
    "emailNudges": "Vikumbusho vya barua pepe",
    "emailNudgesDesc": "Vikumbusho vyema na muhtasari wa kila wiki",
    "on": "Imewashwa",
    "paused": "Imesimama",
    "privacySecurity": "Faragha na usalama",
    "privacySecurityDesc": "Sasisha nenosiri ulinde akaunti",
    "preferencesTitle": "Mapendeleo",
    "preferencesDesc": "Lugha, eneo na ubinafsishaji",
    "supportHelp": "Msaada na Usaidizi",
    "supportHelpDesc": "Pata majibu au wasiliana na msaada",
    "sectionAccount": "Akaunti",
    "sectionSupport": "Msaada",
    "sectionAbout": "Kuhusu",
    "sectionAdmin": "Msimamizi",
    "privacyPolicy": "Sera ya Faragha",
    "terms": "Masharti",
    "appVersion": "Toleo la programu",
    "giveFeedback": "Toa maoni",
    "giveFeedbackDesc": "Tuambie nini cha kuboresha",
    "reportProblem": "Ripoti tatizo",
    "reportProblemDesc": "Umepata hitilafu? Tuambie",
    "adminInsights": "Maarifa ya msimamizi",
    "adminInsightsDesc": "Uchanganuzi wa ushirikishwaji",
    "adminBadge": "Msimamizi",
    "shareWithClinician": "Shiriki na daktari",
    "shareWithClinicianDesc": "Muhtasari wa kusoma tu · huisha kiotomatiki · unaweza kuondoa wakati wowote",
    "share": "Shiriki",
    "profileMayBeOutOfDate": "Wasifu unaweza kuwa wa zamani",
    "profileMayBeOutOfDateDesc": "Hifadhi data sahihi kupata ushauri bora — mabadiliko madogo (uzito, dawa) yanatusaidia.",
    "updateNow": "Sasisha sasa",
    "profileUpdateError": "Hatukuweza kusasisha. Jaribu tena.",
    "healthLoopUser": "Mtumiaji wa HealthLoop",
    "updatedLabel": "Imesasishwa",
    "noEntries": "Hakuna ingizo bado.",
    "completionComplete": "Wasifu wako umekamilika. Tunaweza kukupa mwongozo bora. 💚",
    "completionAlmostThere": "Karibu umemaliza. Maelezo machache zaidi yatatoa ushauri sahihi.",
    "completionInProgress": "Kamilisha wasifu wako kwa maarifa bora ya ustawi.",
    "justNow": "sasa hivi",
    "minAgo": "dakika {{n}} zilizopita",
    "minsAgo": "dakika {{n}} zilizopita",
    "hourAgo": "saa {{n}} iliyopita",
    "hoursAgo": "masaa {{n}} yaliyopita",
    "dayAgo": "siku {{n}} iliyopita",
    "daysAgo": "siku {{n}} zilizopita",
    "checkinDueToday": "Ukaguzi unahitajika leo",
    "checkinDueTonight": "Ukaguzi unahitajika usiku huu"
  },
  "supportDeep": {
    "backToSettings": "Rudi kwenye mipangilio",
    "quickNavAria": "Sehemu za msaada",
    "searchPlaceholder": "Tafuta msaada…",
    "searchAria": "Tafuta katika maswali yanayoulizwa mara kwa mara",
    "resultsCount": "matokeo {{n}}",
    "resultsCountPlural": "matokeo {{n}}",
    "questionsCount": "maswali {{n}}",
    "liveChatTitle": "Soga moja kwa moja",
    "liveChatDesc": "Ongea nasi moja kwa moja · J/tatu–J/tano 9 asubuhi–6 jioni",
    "startChat": "Anza soga",
    "liveChatSoonToast": "Soga moja kwa moja inakuja hivi karibuni. Kwa sasa, barua pepe inafanya kazi vizuri.",
    "emailUsTitle": "Tuandikie",
    "emailUsDesc": "Jibu ndani ya saa 24–48",
    "copy": "Nakili",
    "emailCopied": "Barua pepe imenakiliwa.",
    "contactFormTitle": "Fomu ya mawasiliano",
    "contactFormDesc": "Tutumie ujumbe — tutajibu kwa barua pepe.",
    "yourNameLabel": "Jina lako *",
    "namePlaceholder": "Asha Mwangi",
    "yourEmailLabel": "Barua pepe yako *",
    "emailPlaceholder": "asha@mfano.com",
    "subjectOptional": "Mada (si lazima)",
    "subjectPlaceholder": "Tunaweza kusaidia vipi?",
    "messageLabel": "Ujumbe *",
    "messagePlaceholder": "Tuambie kwa ufupi unachohitaji.",
    "sending": "Inatumwa…",
    "sendMessage": "Tuma ujumbe",
    "messageSent": "Ujumbe umetumwa",
    "messageSentDesc": "Tutajibu ndani ya saa 24–48.",
    "callbackTitle": "Omba kupigiwa simu",
    "callbackDesc": "Tutakupigia wakati unaokufaa.",
    "phoneLabel": "Namba ya simu *",
    "phonePlaceholder": "+254 700 000 000",
    "preferredTimeLabel": "Wakati upendelevu (si lazima)",
    "preferredTimePlaceholder": "mfano: kesho mchana",
    "reasonLabel": "Sababu (si lazima)",
    "reasonPlaceholder": "Kwa ufupi, ungependa kuzungumzia nini?",
    "submitting": "Inawasilisha…",
    "requestCallback": "Omba kupigiwa simu",
    "callbackRequested": "Ombi limepokelewa",
    "callbackRequestedDesc": "Tutawasiliana nawe ndani ya saa 24.",
    "medicationSupport": "Msaada wa dawa",
    "medicationSupportDesc": "Fuatilia maagizo, viongezeo na vikumbusho.",
    "goToMedications": "Nenda kwenye dawa →",
    "specialistConsultation": "Ushauri wa kitaalamu",
    "specialistConsultationDesc": "Ongea na daktari kwa mwongozo binafsi.",
    "connectExpert": "Unganisha na mtaalamu →",
    "videoConsult": "Ushauri wa video",
    "videoConsultDesc": "Panga kikao cha video na mtaalamu.",
    "bookConsultation": "Panga ushauri →",
    "premium": "Premium",
    "healthDisclaimer": "HealthLoop inasaidia ustawi wako wa kila siku — haichukui nafasi ya huduma ya dharura. Ukihitaji haraka, wasiliana na huduma za dharura za eneo lako.",
    "categoryLabel": "Aina",
    "catBug": "Hitilafu",
    "catPerformance": "Utendaji wa polepole",
    "catFeature": "Kipengele hakifanyi kazi",
    "catUi": "Tatizo la kuonyesha",
    "catOther": "Nyingine",
    "issueTitle": "Kichwa cha tatizo *",
    "issueTitlePlaceholder": "Muhtasari mfupi",
    "detailedDescription": "Maelezo ya kina *",
    "detailedDescriptionPlaceholder": "Nini kilitokea? Ulikuwa unafanya nini? Hatua za kuirudia zinatusaidia sana.",
    "autoAttachNote": "Taarifa za kifaa, kivinjari na dirisha zinaambatishwa kiotomatiki.",
    "submitReport": "Wasilisha ripoti",
    "reportSubmitted": "Ripoti imepokelewa",
    "reportSubmittedDesc": "Timu yetu inashughulikia.",
    "fillAllFields": "Tafadhali jaza sehemu zote zinazohitajika",
    "problemReportSubmittedToast": "Ripoti ya tatizo imepokelewa. Tutachunguza na kukurudia.",
    "messageSentToast": "Ujumbe umetumwa. Tutajibu ndani ya saa 24–48.",
    "callRequestedToast": "Ombi la simu limepokelewa. Tutawasiliana nawe ndani ya saa 24.",
    "submitFailGeneric": "Imeshindwa kuwasilisha. Jaribu tena au tuandikie {{email}}.",
    "submitFailContact": "Imeshindwa kutuma. Andika moja kwa moja kwa {{email}}."
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "Wasifu wa afya",
    "notifications": "Arifa",
    "familyAccounts": "Akaunti za familia",
    "settings": "Mipangilio",
    "logout": "Toka",
    "allCaughtUp": "Hakuna kilichobaki.",
    "weekInReview": "Wiki yako kwa muhtasari",
    "dismissNotification": "Ondoa arifa",
    "dismissWeeklyDigest": "Ondoa muhtasari wa wiki",
    "notificationsAria": "Arifa",
    "profileMenuAria": "Fungua menyu ya wasifu",
    "loadingWellness": "Inapakia muhtasari wako wa ustawi",
    "nextTip": "Kidokezo kifuatacho",
    "todayAtGlance": "Leo kwa muhtasari",
    "healthScoreLabel": "Alama ya afya",
    "currentStreakLabel": "Mfululizo wa sasa",
    "todaysProgress": "Maendeleo ya leo",
    "insightForYou": "Maarifa kwako",
    "checkMyHealthRisk": "Angalia hatari ya afya yangu",
    "quickAccess": "Ufikiaji wa haraka",
    "familyCare": "Huduma ya familia",
    "healthLibrary": "Maktaba ya afya",
    "myHealthData": "Data yangu ya afya",
    "askQuestion": "Uliza swali",
    "dashLoadError": "Hatukuweza kupakia dashibodi yako. Jaribu tena.",
    "taskUpdateError": "Hatukuweza kusasisha kazi. Jaribu tena.",
    "perfectDay": "Siku kamilifu! 🎉 Mfululizo umeongezeka.",
    "letsStart": "Hebu tuanze",
    "yourNextStepToday": "Hatua yako inayofuata leo",
    "completeDailyCheck": "Kamilisha ukaguzi wako wa afya wa kila siku",
    "startDailyCheck": "Anza ukaguzi wa kila siku",
    "viewAll": "Tazama yote",
    "graceProtected": "Imelindwa kwa muda",
    "todaysHealthRecommendations": "Mapendekezo ya afya ya leo",
    "updateViaCheck": "Sasisha kupitia ukaguzi",
    "healthInsight": "Maarifa ya afya",
    "riskCheckSubtext": "Pata maarifa ya afya ya kibinafsi kwa sekunde chache",
    "foodDiet": "Chakula",
    "healthScoreNew": "Alama ya afya · Mpya",
    "letsBuildScore": "Hebu tuijenge alama yako ya afya pamoja",
    "oneHealthyHabitAtATime": "Tabia moja yenye afya kwa wakati.",
    "nextCheck": "Ukaguzi unaofuata:",
    "todayAt8pm": "leo saa 2 usiku",
    "wellnessTipForYou": "Kidokezo cha ustawi cha leo · Kwako",
    "wellnessTipForFactor": "Kidokezo cha ustawi cha leo · Kwa {{factor}} yako",
    "logged": "Imewekwa",
    "gotIt": "Nimeelewa 👍",
    "gladToSeeYou": "Tunafurahi kukuona leo 💚",
    "takesLessThan60Sec": "Chini ya sekunde 60",
    "scoreReadyWhenYou": "Tuko tayari ukiwa tayari",
    "scoreCompleteFirstCheck": "Kamilisha ukaguzi wako wa kwanza ufungue maarifa binafsi.",
    "scoreExcellent": "Bora kabisa",
    "scoreSupportExcellent": "Uko katika hali nzuri leo. Endelea hivyo!",
    "scoreGood": "Vizuri",
    "scoreSupportGood": "Unaendelea vyema. Endelea na tabia zako nzuri.",
    "scoreModerate": "Wastani",
    "scoreSupportModerate": "Unaendelea vyema, lakini maeneo machache yanahitaji uangalifu.",
    "scoreNeedsAttention": "Inahitaji uangalifu",
    "scoreSupportNeedsAttention": "Afya yako inahitaji uangalifu leo. Mabadiliko madogo yanaweza kusaidia."
  },
  "emailVerify": {
    "bannerWithEmail": "Tafadhali thibitisha barua pepe ({{email}}) ili tulinde akaunti yako na kukutumia vikumbusho.",
    "bannerNoEmail": "Tafadhali thibitisha barua pepe ili tulinde akaunti yako.",
    "sending": "Inatumwa…",
    "resend": "Tuma tena",
    "sentToast": "Barua pepe ya uthibitisho imetumwa. Angalia kisanduku chako.",
    "sendFailToast": "Imeshindwa kutuma. Jaribu baadaye."
  },
  "forgotPassword": {
    "title": "Umesahau nenosiri?",
    "subtitle": "Usijali! Andika barua pepe yako, tutakutumia maelekezo.",
    "emailLabel": "Anwani ya barua pepe",
    "emailPlaceholder": "yako@mfano.com",
    "sendResetLink": "Tuma kiungo",
    "sending": "Inatumwa…",
    "backToLogin": "Rudi kuingia",
    "resendLink": "Tuma barua pepe tena",
    "successTitle": "Angalia barua pepe yako",
    "successBody": "Iwapo akaunti ipo kwa {{email}}, tumetuma kiungo cha kubadilisha.",
    "linkExpires": "Kiungo kitaisha baada ya dakika 30.",
    "successToast": "Angalia barua pepe yako kwa maelekezo",
    "errEmptyEmail": "Tafadhali andika barua pepe yako",
    "errInvalidEmail": "Andika barua pepe halali",
    "errNetwork": "Imeshindwa kufikia seva. Angalia muunganiko wako.",
    "errGeneric": "Imeshindwa kutuma. Jaribu tena au wasiliana na msaada."
  },
  "resetPassword": {
    "title": "Weka nenosiri jipya",
    "subtitle": "Tengeneza nenosiri imara la akaunti yako",
    "newPasswordLabel": "Nenosiri jipya",
    "newPasswordPlaceholder": "Ingiza nenosiri jipya",
    "confirmPasswordLabel": "Thibitisha nenosiri",
    "confirmPasswordPlaceholder": "Thibitisha nenosiri jipya",
    "requirementsHint": "Lazima liwe na herufi 8 zaidi, kubwa, ndogo na nambari",
    "resetPassword": "Badilisha nenosiri",
    "resetting": "Inabadilisha…",
    "successTitle": "Nenosiri limebadilishwa!",
    "successBody": "Sasa unaweza kuingia kwa nenosiri jipya.",
    "successToast": "Nenosiri limebadilishwa kwa mafanikio!",
    "goToLogin": "Nenda kuingia",
    "invalidLinkTitle": "Kiungo si halali",
    "invalidLinkBody": "Kiungo hiki si halali au kimeisha muda.",
    "requestNewLink": "Omba kiungo kipya",
    "showPassword": "Onyesha nenosiri",
    "hidePassword": "Ficha nenosiri",
    "errInvalidLink": "Kiungo cha kubadilisha si halali",
    "errMismatch": "Manenosiri hayalingani",
    "errTooShort": "Nenosiri lazima liwe na herufi 8 au zaidi",
    "errExpiredToken": "Kiungo hiki kimeisha muda au si halali. Omba kipya.",
    "errNetwork": "Imeshindwa kufikia seva. Angalia muunganiko.",
    "errGeneric": "Imeshindwa kubadilisha. Jaribu tena."
  },
  "tips": {
    "water1": "Kunywa maji ndani ya dakika 30 baada ya kuamka kunaweza kuboresha unyevu na nguvu.",
    "water2": "Glasi ya maji kabla ya kila mlo ni njia laini ya kushinda kiu.",
    "water3": "Kuongeza ukanda wa ndimu au majani machache ya minti hufanya unyevu kuwa tamu.",
    "meals1": "Kuongeza sehemu moja ya mboga kwa siku kunaimarisha afya ya utumbo na moyo.",
    "meals2": "Konzi ya karanga au mbegu kifungua kinywa hutuliza nguvu zako asubuhi.",
    "meals3": "Tunda zima ni bora kuliko juisi — nyuzi hutuliza sukari ya damu.",
    "steps1": "Matembezi ya dakika 10 baada ya milo husaidia mwili kuchakata sukari kwa upole.",
    "steps2": "Mazoezi ya kunyoosha ya dakika 5 asubuhi yapunguza mvutano na kutuliza siku yako.",
    "steps3": "Kupanda ngazi mara moja kwa siku huimarisha moyo kwa wiki zinazofuata.",
    "sleep1": "Kupunguza mwanga saa moja kabla ya kulala husaidia mwili kushuka kwa usingizi mzito.",
    "sleep2": "Saa thabiti ya kuamka — hata wikendi — hutuliza mzunguko wa usingizi.",
    "sleep3": "Dakika 10 za jua la asubuhi husaidia kudhibiti mfumo wako wa usingizi kawaida.",
    "general1": "Dakika mbili za kupumua taratibu zinaweza kupunguza msongo na kutuliza umakini.",
    "general2": "Tambua wakati mmoja wa shukrani leo — ushindi mdogo wa akili pia hujumlika.",
    "general3": "Ulijitokeza leo. Hii ndiyo tabia inayofanya kila tabia nyingine kuwa rahisi."
  },
  "factors": {
    "hydration": "unyevu",
    "nutrition": "lishe",
    "movement": "mwendo",
    "sleep": "usingizi"
  },
  "nutritionDeep": {
    "sectionSnapshot": "Muhtasari wa lishe wa kila siku",
    "sectionSnapshotSubtitle": "Mtazamo wa haraka wa unyevu, kalori, na uwiano wa milo wa leo.",
    "mealOptionsLoadFail": "Imeshindwa kupakia chaguo za mlo",
    "prefsSaved": "Mapendeleo ya chakula yamehifadhiwa! Inarejea milo...",
    "prefsSaveFail": "Imeshindwa kuhifadhi mapendeleo",
    "newOptionsFail": "Imeshindwa kupakia chaguo mpya",
    "invalidZip": "Tafadhali ingiza msimbo halali wa posta wa nambari 5",
    "noVendorsArea": "Hakuna wachuuzi katika eneo hili bado. Tunapanua huduma!",
    "vendorsFetchFail": "Imeshindwa kupata wachuuzi",
    "selectVendorFirst": "Tafadhali chagua mchuuzi wa utoaji kwanza",
    "removedFromCart": "Imeondolewa kwenye kikapu",
    "orderPlaced": "Agizo limewekwa kwa mafanikio! 🎉",
    "enterZipFirst": "Ingiza msimbo wako wa posta katika sehemu ya utoaji kwanza",
    "mealNotAvailable": "Mlo huu haupatikani kwa utoaji katika eneo lako bado",
    "mealUnavailable": "Mlo huu haupatikani kwa wachuuzi wa karibu",
    "vendorOptionsFail": "Imeshindwa kupakia chaguo za mchuuzi",
    "favoriteSaveFail": "Imeshindwa kuhifadhi kipenzi",
    "removedFromFavorites": "Imeondolewa kwenye vipenzi",
    "favoriteRemoveFail": "Imeshindwa kuondoa kipenzi",
    "cartEmpty": "Kikapu chako hakina kitu",
    "noMealOptions": "Hakuna chaguo za mlo zinazopatikana",
    "loadingOptions": "Inapakia chaguo za mlo...",
    "selectPreferences": "Chagua mapendeleo yako ya chakula",
    "mealBuilder": "Mjengo wa mlo",
    "myFavorites": "Vipenzi vyangu",
    "myFavoriteMeals": "Milo yangu ya kupendwa",
    "noFavoritesYet": "Hakuna milo ya kupendwa bado!",
    "price": "Bei",
    "delivery": "Utoaji",
    "deliveryFee": "Ada ya utoaji",
    "distance": "Umbali",
    "subtotal": "Jumla ndogo",
    "total": "Jumla",
    "orderNumber": "Nambari ya agizo",
    "vendor": "Mchuuzi",
    "totalAmount": "Kiasi cha jumla",
    "estimatedDelivery": "Utoaji unaokadiriwa",
    "whyThisMeal": "Kwa nini mlo huu",
    "selectThisMeal": "Chagua mlo huu",
    "swapMeal": "Badilisha mlo",
    "orderThisMeal": "Agiza mlo huu",
    "notAvailableNearYou": "Hauipatikani karibu nawe",
    "tryAdjustingPrefs": "Jaribu kurekebisha mapendeleo yako ya chakula kuona mapendekezo",
    "myMealPlanSummary": "Mpango wangu wa milo",
    "saveCompletePlan": "Hifadhi mpango kamili",
    "yourFoodPreferences": "Mapendeleo yako ya chakula",
    "editPreferences": "Hariri mapendeleo",
    "healthyMealDelivery": "Utoaji wa milo yenye afya",
    "enableDelivery": "Wezesha utoaji",
    "enterZipCode": "Ingiza msimbo wako wa posta uone milo inayopatikana",
    "savePreferences": "Hifadhi mapendeleo",
    "quickAccessSavedMeals": "Ufikiaji wa haraka wa milo iliyohifadhiwa",
    "saveMealsFromBuilder": "Hifadhi milo kutoka tabu ya Mjengo wa Mlo",
    "chooseVendor": "Chagua mchuuzi wa kuagiza mlo huu",
    "yourCart": "Kikapu chako",
    "addMealsToStart": "Ongeza milo kutoka chaguo hapa chini",
    "orderPlacedDesc": "Agizo lako la mlo wa afya limewekwa kwa mafanikio",
    "continueShopping": "Endelea kununua",
    "trackOrder": "Fuatilia agizo",
    "healthyStoresTitle": "Maduka ya Vyakula Bora na Masoko ya Afya Karibu nawe",
    "healthyStoresIntro": "Aina za maduka yanayojumuisha tamaduni mbalimbali za kutafuta katika eneo lako — kwa ajili ya mawazo ya ununuzi, si utoaji wa huduma.",
    "healthyStoresGuidanceTitle": "Mwongozo wa ununuzi wa vyakula bora",
    "healthyStoresDisclaimer": "HealthLoop hutoa hamasa ya jumla ya ustawi na ununuzi wa vyakula bora pekee — si ushauri wa matibabu au lishe.",
    "healthyStores": {
      "organic": {
        "type": "Maduka ya vyakula asilia (Organic)",
        "description": "Mazao mabichi yasiyo na viuatilifu na bidhaa za jikoni zilizochakatwa kwa kiasi kidogo.",
        "tags": [
          "Vyakula asilia",
          "Mazao mabichi"
        ]
      },
      "farmers": {
        "type": "Masoko ya wakulima",
        "description": "Matunda ya msimu yaliyolimwa kienyeji, mboga, na mazao ya asili moja kwa moja kutoka kwa wakulima.",
        "tags": [
          "Kienyeji",
          "Ya msimu"
        ]
      },
      "african": {
        "type": "Maduka ya mazao mabichi ya Kiafrika",
        "description": "Vihama, ndizi mzuzu, mboga za majani, nazi, na vyakula vikuu vya Afrika Magharibi na Mashariki.",
        "tags": [
          "Kiutamaduni",
          "Mazao mabichi"
        ]
      },
      "caribbean": {
        "type": "Masoko ya vyakula vya asili vya Karibiani",
        "description": "Callaloo, mihogo, pilipili mbuzi, ackee, shehena na vyakula vikuu vya visiwani.",
        "tags": [
          "Kiutamaduni",
          "Vyakula asilia"
        ]
      },
      "asian": {
        "type": "Maduka makubwa ya mboga za Kiasia",
        "description": "Bok choy, daikon, mizizi ya lotus, tofu, mitishamba mibichi na vyakula vikuu vya Kiasia.",
        "tags": [
          "Kiutamaduni",
          "Mazao mabichi"
        ]
      },
      "halal": {
        "type": "Masoko ya vyakula bora vya Halal",
        "description": "Protini zenye mafuta kidogo zilizoidhinishwa kuwa Halal, mazao mabichi na viungo vya asili.",
        "tags": [
          "Halal",
          "Kiutamaduni"
        ]
      },
      "mediterranean": {
        "type": "Masoko ya vyakula asilia ya Mediterania",
        "description": "Mafuta ya zeituni, kunde, mitishamba mibichi, nafaka zisizokobolewa na vyakula vya Mediterania.",
        "tags": [
          "Kiutamaduni",
          "Vyakula asilia"
        ]
      },
      "wellness": {
        "type": "Maduka ya vyakula yanayozingatia ustawi",
        "description": "Vyakula asilia vilivyoteuliwa, chaguzi za mimea, na bidhaa za jikoni zenye viambato safi.",
        "tags": [
          "Vyakula asilia",
          "Inayotokana na mimea"
        ]
      }
    },
    "healthyShoppingTips": [
      "Anza na maeneo ya pembeni ya duka — mazao mabichi, protini, na maziwa ya mimea kwa kawaida hupatikana pembeni.",
      "Pendelea vyakula asilia vyenye kiambato kimoja badala ya vile vilivyochakatwa sana.",
      "Chagua mazao ya msimu ya kienyeji — kwa kawaida huwa mabichi zaidi, bei nafuu na yenye virutubisho vingi.",
      "Waulize wauzaji kuhusu asili na mbinu za ukulima — wengi watafurahi kukueleza."
    ]
  },
  "messages": {
    "success": "Success!",
    "error": "Error",
    "saved": "Saved successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "confirmDelete": "Are you sure you want to delete this?",
    "networkError": "Network error. Please try again.",
    "somethingWrong": "Something went wrong",
    "failedToLoad": "Failed to load dashboard",
    "offlineMode": "Offline mode - showing limited data",
    "locationDenied": "Location access denied. Check browser settings to enable.",
    "locationUnavailable": "Location information unavailable",
    "locationTimeout": "Location request timed out. Please try again.",
    "locationError": "Unable to access location",
    "locationGranted": "Location access granted! Showing nearby options",
    "locationNotSupported": "Location services not supported by your browser",
    "requestingLocation": "Requesting location access..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Preventive Health Tracker",
    "educationHub": "Education Hub",
    "engagementWidget": "Engagement Widget",
    "wellnessCheckIn": "Wellness Check-In",
    "todaysMetrics": "Today's Metrics",
    "bloodPressure": "Blood Pressure",
    "heartRate": "Heart Rate",
    "weight": "Weight",
    "sleep": "Sleep",
    "waterIntake": "Water Intake",
    "exercise": "Exercise",
    "logMetric": "Log Metric",
    "viewHistory": "View History"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Health Reminders",
    "subtitle": "Stay on track with personalized health notifications",
    "breakfast": "Breakfast Reminder",
    "lunch": "Lunch Reminder",
    "dinner": "Dinner Reminder",
    "water": "Water Intake",
    "movement": "Movement Break",
    "sleep": "Sleep Reminder",
    "wellness": "Wellness Check-In",
    "healthLogging": "Health Logging",
    "annualCheckup": "Annual Checkup",
    "enable": "Enable",
    "disable": "Disable",
    "customize": "Customize Time",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "Jiunge na HealthLoop",
    "subtitle": "Anza safari yako ya afya ya kinga leo",
    "fullName": "Jina kamili",
    "email": "Barua pepe",
    "password": "Nenosiri",
    "confirmPassword": "Thibitisha nenosiri",
    "createAccount": "Fungua akaunti",
    "haveAccount": "Tayari una akaunti?",
    "signIn": "Ingia",
    "creating": "Inafungua akaunti...",
    "passwordTooShort": "Nenosiri lazima liwe na herufi 8 au zaidi",
    "setupBiometric": "Sanidi kuingia kwa biometriki",
    "setupBiometricDesc": "Tumia alama ya kidole, Face ID au Windows Hello kwa kuingia haraka na salama",
    "setupNow": "Sanidi sasa",
    "skipForNow": "Baadaye",
    "settingUp": "Inasanidi...",
    "benefit1": "Hakuna nenosiri za kukumbuka",
    "benefit2": "Usalama wa ziada kwa biometriki",
    "benefit3": "Ingia kwa mguso mmoja au mtazamo",
    "biometricPrivacy": "Data yako ya biometriki haitoki kwenye kifaa chako",
    "biometricSuccess": "Kuingia kwa biometriki kumesanidiwa! 🎉",
    "biometricFailed": "Imeshindwa kusanidi biometriki. Unaweza kusanidi baadaye katika mipangilio.",
    "biometricSetupLater": "Unaweza kusanidi kuingia kwa biometriki baadaye katika wasifu wako"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
